module.exports = __webpack_public_path__ + "img/boohgle_auth_print_image.4c62438c.jpg";